
    import * as React from 'react';

    const Search16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M13.534 13.996l-3.212-3.203a5.017 5.017 0 11.471-.47L14 13.529l-.466.466zm-1.636-2.57l-1.105-1.104 1.105 1.105zm-1.803-7.485a4.352 4.352 0 00-6.155 6.153 4.352 4.352 0 006.155-6.153z" /></svg>
        </div>
      );
    };

    Search16.displayName = 'Search16';

    export default Search16;
  